<template>
  <div class="zoom-link-converter">
    <div class="card card-custom">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">Công Cụ Chuyển Đổi Link</h3>
        </div>
        <!-- <div class="card-toolbar">
          
        </div> -->
      </div>
      <div class="card-body">
        <div class="text-center text-muted py-5">
          <i class="fas fa-link fa-3x mb-3"></i>
          <p></p>
          <button class="btn btn-success btn-lg" @click="openModal">
            <i class="fas fa-plus mr-2"></i>Chuyển đổi Link Zoom
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Popup using Bootstrap Vue -->
    <b-modal id="zoom-converter-modal" ref="zoomConverterModal" title="Zoom Link Converter" size="lg"
      no-close-on-backdrop no-close-on-esc @hidden="onModalHidden">
      <template #modal-header>
        <div class="d-flex align-items-center w-100">
          <i class="fas fa-video mr-2 text-primary"></i>
          <h5 class="mb-0">Zoom Link Converter</h5>
        </div>
      </template>

      <!-- Option Selection -->
      <div class="form-group">
        <label class="font-weight-bold d-block mb-3">Chọn loại link <span class="text-danger">*</span></label>
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="option-card" :class="{ 'option-card-active': linkType === 'website' }">
              <input type="radio" v-model="linkType" value="website" class="d-none" />
              <span class="option-card-icon">
                <i class="fas fa-globe text-primary"></i>
              </span>
              <span class="option-card-text">Link Zoom Support Website</span>
            </label>
          </div>
          <div class="col-md-6 mb-2">
            <label class="option-card" :class="{ 'option-card-active': linkType === 'inapp' }">
              <input type="radio" v-model="linkType" value="inapp" class="d-none" />
              <span class="option-card-icon">
                <i class="fas fa-mobile-alt text-success"></i>
              </span>
              <span class="option-card-text">Link Zoom In App DIAB</span>
            </label>
          </div>
        </div>
      </div>

      <hr class="my-3" />

      <!-- Zoom Link Input (for auto detect) -->
      <div class="form-group">
        <label class="font-weight-bold">Paste Zoom Link <span class="text-danger">*</span></label>
        <textarea v-model="zoomLink" class="form-control" rows="2"
          placeholder="Paste Zoom link (example: https://zoom.us/j/123456789?pwd=abc123)"
          @input="onZoomLinkChange"></textarea>
        <small class="text-muted">Tự động detect Meeting ID, Password và điền vào các trường bên dưới</small>
      </div>

      <!-- Detected Info -->
      <!-- <div v-if="meetingId || password" class="btn btn-success" style="left: 20px;">
        <strong>Detected:</strong>
        <span v-if="meetingId" class="ml-3">Meeting ID: <strong>{{ meetingId }}</strong></span>
        <span v-if="password" class="ml-3">Password: <strong>{{ password }}</strong></span>
      </div> -->
      <!-- Form Fields for "Link Zoom Support Website" -->

      <template v-if="linkType === 'website'">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Meeting ID <span class="text-danger">*</span></label>
              <input v-model="meetingId" type="text" class="form-control" placeholder="Enter Meeting ID" disabled="true"/>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Password <span class="text-danger">*</span></label>
              <input v-model="password" type="text" class="form-control" placeholder="Enter Password" disabled="true"/>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>User Name <span class="text-danger">*</span></label>
              <input v-model="userName" type="text" class="form-control" placeholder="Enter User Name" />
            </div>
          </div>
        </div>
      </template>
      <!-- Form Fields for "Link Zoom In App DIAB" -->

      <template v-if="linkType === 'inapp'">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Meeting ID <span class="text-danger">*</span></label>
              <input v-model="meetingId" type="text" class="form-control" placeholder="Enter Meeting ID" disabled="true"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Meeting Password <span class="text-danger">*</span></label>
              <input v-model="password" type="text" class="form-control" placeholder="Enter Meeting Password" disabled="true"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Topic <span class="text-danger">*</span></label>
              <input v-model="topic" type="text" class="form-control" placeholder="Enter Topic" />
            </div>
          </div>
          <!-- <div class="col-md-6">
            <div class="form-group">
              <label>Email <span class="text-danger">*</span></label>
              <input v-model="email" type="email" class="form-control" placeholder="Enter Email Của Host" />
            </div>
          </div> -->
            <div class="col-md-6">
        <div class="form-group">
          <label>Zoom Client Link <span class="text-danger">*</span></label>
          <textarea v-model="zoomClientLink" class="form-control" rows="2"
            placeholder="Zoom Client Link (auto-filled from pasted link)" disabled="true"></textarea>
        </div>
        </div>
      
      </div>
      </template>
              <label><span class="text-danger">Note: Không dùng link zoom host để paste vào, chỉ dành cho link zoom user</span></label>

      <!-- Error -->
      <div v-if="error" class="alert alert-danger py-2">
        <strong>Error:</strong> {{ error }}
      </div>

      <template #modal-footer>
        <button class="btn btn-secondary" @click="closeModal">
          <i class="fas fa-times mr-1"></i>Hủy
        </button>
        <button class="btn btn-secondary" @click="resetForm">
          <i class="fas fa-redo mr-1"></i>Reset
        </button>
        <button class="btn btn-success" :disabled="!canConvert || isLoading" @click="convertLink">
          <span v-if="isLoading">
            <i class="fas fa-spinner fa-spin mr-1"></i>Converting...
          </span>
          <span v-else>
            <i class="fas fa-sync-alt mr-1"></i>Convert
          </span>
        </button>
      </template>
    </b-modal>

    <!-- Result Modal - hiển thị sau khi convert thành công -->
    <b-modal id="zoom-result-modal" ref="zoomResultModal" title="Kết quả chuyển đổi" size="lg"
      centered hide-header-close >
      <template #modal-header>
        <div class="d-flex align-items-center w-100">
          <i class="fas fa-check-circle mr-2 text-success fa-lg"></i>
          <h5 class="mb-0 font-weight-bold">Chuyển đổi thành công!</h5>
        </div>
      </template>

      <div class="form-group mb-4">
        <label class="font-weight-bold mb-2">Link đã tạo:</label>
        <div class="input-group">
          <input v-model="result" type="text" class="form-control form-control-lg" readonly
            style="background-color: #f5f5f5;" />
        </div>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-center w-100">
          <button class="btn btn-primary btn-lg mx-2" @click="copyToClipboard"
            :title="copied ? 'Copied!' : 'Copy to clipboard'">
            <i :class="copied ? 'fas fa-check' : 'fas fa-copy'" class="mr-2"></i>
            {{ copied ? 'Đã copy!' : 'Copy Link' }}
          </button>
          <button v-if="generatedId"
            class="btn btn-lg mx-2"
            :class="linkType === 'inapp' ? 'btn-secondary' : 'btn-success'"
            :disabled="linkType === 'inapp'"
            @click="testGeneratedLink"
            :title="linkType === 'inapp' ? 'Thao tác trên điện thoại' : 'Test link vừa tạo'">
            <i :class="linkType === 'inapp' ? 'fas fa-mobile-alt mr-2' : 'fas fa-external-link-alt mr-2'"></i>
            {{ linkType === 'inapp' ? 'Thao tác trên điện thoại' : 'Kiểm tra Link' }}
          </button>
          <button class="btn btn-success btn-lg mx-2" @click="createNew">
            <i class="fas fa-plus mr-2"></i>
            Tạo thêm
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ZoomLinkConverter',
  data() {
    return {
      linkType: 'inapp', // 'inapp' or 'website'
      zoomLink: '',
      // Common fields
      meetingId: '',
      password: '',
      // In App DIAB fields
      userName: '',
      // Website fields
      topic: '',
      // email: '',
      zoomClientLink: '',
      // State
      isLoading: false,
      result: '',
      error: '',
      copied: false,
      responseDetails: null,
      generatedId: null, // ID của file được tạo để test
    };
  },
  computed: {
    canConvert() {
      if (this.linkType === 'website') {
        return this.meetingId && this.password && this.userName;
      } else {
        // website - all fields required
        return (
          this.meetingId &&
          this.password &&
          this.topic &&
          // this.email &&
          this.zoomClientLink
        );
      }
    },
    zoomBaseUrl() {
      // Nếu VUE_APP_API chứa "diab.com.vn" thì dùng "zoom.link.diab.com.vn", ngược lại dùng "zoom.link.diab.vn"
      const apiUrl = process.env.VUE_APP_API || '';
      if (apiUrl.includes('diab.com.vn')) {
        return 'https://zoom.link.diab.com.vn';
      }
      return 'https://zoom.link.diab.vn';
    },
  },
  mounted() {
    // Force open modal when page loads
    this.$nextTick(() => {
      this.$bvModal.show('zoom-converter-modal');
    });
  },
  methods: {
    openModal() {
      this.resetForm();
      this.$bvModal.show('zoom-converter-modal');
    },

    closeModal() {
      this.$bvModal.hide('zoom-converter-modal');
    },

    onModalHidden() {
      // Optional: do something when modal is closed
    },

    onZoomLinkChange() {
      const parsed = this.parseZoomLink(this.zoomLink);
      if (parsed.meetingId) {
        this.meetingId = parsed.meetingId;
      }
      if (parsed.password) {
        this.password = parsed.password;
      }
      // Auto fill zoomClientLink with the pasted link
      if (this.zoomLink) {
        this.zoomClientLink = this.zoomLink;
      }
    },

    parseZoomLink(link) {
      const result = {
        meetingId: null,
        password: null,
      };

      if (!link) return result;

      // Pattern 1: https://zoom.us/j/MEETING_ID?pwd=PASSWORD
      // Pattern 2: https://us02web.zoom.us/j/MEETING_ID?pwd=PASSWORD
      const meetingIdMatch = link.match(/\/j\/(\d+)/);
      if (meetingIdMatch) {
        result.meetingId = meetingIdMatch[1];
      } else {
        // Try to find meeting ID as plain number (9-11 digits typically)
        const plainIdMatch = link.match(/\b(\d{9,11})\b/);
        if (plainIdMatch) {
          result.meetingId = plainIdMatch[1];
        }
      }

      // Extract password
      const pwdMatch = link.match(/[?&]pwd=([^&\s]+)/);
      if (pwdMatch) {
        result.password = pwdMatch[1];
      } else {
        // Try common password patterns
        const passMatch = link.match(/(?:password|passcode)[:\s]+([^\s]+)/i);
        if (passMatch) {
          result.password = passMatch[1];
        }
      }

      return result;
    },

    async convertLink() {
      this.isLoading = true;
      this.error = '';
      this.generatedId = null;

      try {
        let response;
        let formData = new FormData();

        if (this.linkType === 'website') {
          // Call API convert-zoom-app (Link Zoom Support Website)
          formData.append('meetingId', this.meetingId);
          formData.append('meetingPassword', this.password);
          formData.append('userName', this.userName);

          response = await this.$api.post('/Zoom/convert-zoom-app', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        } else {
          // Call API convert-diab-app (Link Zoom In App DIAB)
          formData.append('meetingId', this.meetingId);
          formData.append('meetingPassword', this.password);
          // formData.append('email', this.email);
          formData.append('topic', this.topic);
          formData.append('zoomClientLink', this.zoomClientLink);

          response = await this.$api.post('/Zoom/convert-diab-app', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }

        this.responseDetails = response;

        // Extract link từ response
        // Response structure: { message, link: { branchioLink, id, ... } }
        const linkData = response.link || response;

        if (typeof linkData.branchioLink === 'string') {
          // Có branchioLink -> hiển thị branchioLink
          this.result = linkData.branchioLink;
          this.generatedId = linkData.id || null;
        } else if (typeof linkData === 'string') {
          // link là file path -> chuyển thành URL
          const fileId = this.extractFileId(linkData);
          if (fileId) {
            this.generatedId = fileId;
            this.result = `${this.zoomBaseUrl}/${fileId}`;
          } else {
            this.result = linkData;
          }
        } else if (linkData.id) {
          // Có id -> tạo URL từ id
          this.generatedId = linkData.id;
          this.result = `${this.zoomBaseUrl}/${linkData.id}`;
        } else {
          // Fallback
          console.log('Response structure:', response);
          this.result = 'Không thể lấy link từ response';
        }

        this.$toastr.s({
          title: 'Thành công!',
          msg: typeof response.message === 'string' ? response.message : 'Đã tạo link thành công',
        });

        // Close input modal and open result modal
        this.closeModal();
        this.$nextTick(() => {
          this.$bvModal.show('zoom-result-modal');
        });
      } catch (err) {
        console.error('Convert error:', err);
        const errorData = err.response?.data;
        if (typeof errorData === 'string') {
          this.error = errorData;
        } else if (errorData?.message) {
          this.error = errorData.message;
        } else if (err.message) {
          this.error = err.message;
        } else {
          this.error = 'Đã có lỗi xảy ra khi convert link';
        }
        this.$toastr.e({
          title: 'Lỗi!',
          msg: this.error,
        });
      } finally {
        this.isLoading = false;
      }
    },

    extractFileId(filePath) {
      // Trích xuất ID từ file path (ví dụ: Files\html\zoom\87412697122.html -> 87412697122)
      if (!filePath || typeof filePath !== 'string') return null;
      // Lấy tên file từ path
      const fileName = filePath.split(/[/\\]/).pop();
      // Bỏ extension .html
      const id = fileName?.replace(/\.html$/i, '');
      return id || null;
    },

    extractIdFromLink(link) {
      // Trích xuất ID từ link (ví dụ: https://api.diab.vn/App/Zoom/convert/abc123 -> abc123)
      if (!link || typeof link !== 'string') return;
      const match = link.match(/\/convert\/([^/?#]+)/);
      if (match) {
        this.generatedId = match[1];
      } else {
        // Nếu link là ID trực tiếp
        const parts = link.split('/');
        this.generatedId = parts[parts.length - 1];
      }
    },

    testGeneratedLink() {
      if (!this.generatedId) return;
      // Mở link test trong tab mới
      const testUrl = `${this.zoomBaseUrl}/${this.generatedId}`;
      window.open(testUrl, '_blank');
    },

    copyToClipboard() {
      if (!this.result) return;

      navigator.clipboard
        .writeText(this.result)
        .then(() => {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        })
        .catch((err) => {
          console.error('Copy failed:', err);
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = this.result;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        });
    },

    resetForm() {
      this.zoomLink = '';
      this.meetingId = '';
      this.password = '';
      this.userName = '';
      this.topic = '';
      // this.email = '';
      this.zoomClientLink = '';
      this.error = '';
      this.generatedId = null;
    },

    createNew() {
      // Đóng result modal và mở input modal
      this.$bvModal.hide('zoom-result-modal');
      this.resetForm();
      this.result = '';
      this.$nextTick(() => {
        this.$bvModal.show('zoom-converter-modal');
      });
    },

    closeResultModal() {
      this.$bvModal.hide('zoom-result-modal');
    },
  },
};
</script>

<style scoped>
.zoom-link-converter {
  max-width: 900px;
  margin: 0 auto;
}

pre {
  max-height: 300px;
  overflow: auto;
  font-size: 12px;
}

/* Option Card Styling */
.option-card {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border: 2px solid #e4e6ef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
  margin: 0;
  width: 100%;
}

.option-card:hover {
  border-color: #3699ff;
  background-color: #f3f6f9;
}

.option-card-active {
  border-color: #3699ff;
  background-color: #e1f0ff;
}

.option-card-icon {
  font-size: 24px;
  margin-right: 15px;
}

.option-card-text {
  font-weight: 500;
  font-size: 14px;
  color: #3f4254;
}

.radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 0;
}

.radio input {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  accent-color: #3699ff;
}
</style>
